import { apiClient } from '@/shared/lib/api'
import type { User } from '@/shared/stores/auth'
import { updateGiftCardProfile } from '@/features/profile/api'
import type {
  TopupRequest,
  TopupResponse,
  RedeemRequest,
  RedeemGiftCardResponse,
  WithdrawRequest,
  WithdrawResponse,
  SetLightningAddressRequest,
  SetLightningAddressResponse,
  SetAutoWithdrawRequest,
  SetAutoWithdrawResponse,
} from './types'

export async function getBalances(): Promise<User> {
  return apiClient('/users/me')
}

export async function createTopup(payload: TopupRequest): Promise<TopupResponse> {
  return apiClient('/users/me/topup', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export async function redeemGiftCard({ code }: RedeemRequest): Promise<RedeemGiftCardResponse> {
  return apiClient(`/users/me/redeem?code=${encodeURIComponent(code)}`)
}

export async function withdrawSats(payload: WithdrawRequest): Promise<WithdrawResponse> {
  const body: Record<string, unknown> = { address: payload.address }
  if (payload.amount !== undefined && payload.amount !== null) {
    body.amount = payload.amount
  }

  return apiClient('/users/me/withdraw', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export async function setLightningAddress(
  payload: SetLightningAddressRequest
): Promise<SetLightningAddressResponse> {
  await updateGiftCardProfile(payload)
  return true
}

export async function setAutoWithdraw(
  payload: SetAutoWithdrawRequest
): Promise<SetAutoWithdrawResponse> {
  await updateGiftCardProfile(payload)
  return true
}
